import { useQuery } from "react-query";
import { getImportAppSources } from "api/Appointment";

export const useImportSources = () => {
    const { data, isLoading } = useQuery<Array<any> | any>(["app-import-sources"],
        () => {
            return getImportAppSources();
        },
    );

    return {
        data,
        isLoading,
    };
};
